import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceService } from 'src/app/core/device.service';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { Flashcard } from 'src/app/models/flashcard.model';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-flashcards-preview',
  templateUrl: './flashcards-preview.component.html',
  styleUrls: ['./flashcards-preview.component.scss'],
  standalone: false
})
export class FlashcardsPreview {

  @Input() isDemo: boolean = false;
  @Input() learnset?: Learnset;
  @Input() flashcards?: Flashcard[];
  @Output() navigateBack: EventEmitter<void> = new EventEmitter<void>();

  deviceSize: 'mobile' | 'tablet' | 'desktop';
  isLoading: boolean = false;

  constructor(
    private deviceService: DeviceService,
    private flashcardService: FlashcardService,
    private router: Router
  ) {
    this.deviceSize = this.deviceService.getDeviceSize();
  }

  ngOnInit() {
  }

  handleFlashcardAction(flashcard: any, action: string) {
    /*if (action === 'delete') {
      const pageIndex = this.pages!.findIndex((p) => p === page);
      const flashcardIndex = this.pages![pageIndex].findIndex((f: Flashcard) => f.id === flashcard.id);
      this.pages![pageIndex].splice(flashcardIndex, 1);
      
      const pageIndexFiltered = this.filteredPages!.findIndex((p) => p === page);
      const flashcardIndexFiltered = this.filteredPages![pageIndexFiltered].findIndex((f: Flashcard) => f.id === flashcard.id);
      this.filteredPages![pageIndexFiltered].splice(flashcardIndexFiltered, 1);
      
      this.pagesChange.emit(this.pages!);
    }*/
  }

  goBack() {
    this.navigateBack.emit();
  }

  saveFlashcards() {
    if (this.isDemo) {
      return;
    }

    this.isLoading = true;

    this.flashcards!.map((flashcard: any) => {
      flashcard.learnset_id = this.learnset!.id;
      return flashcard;
    });

    this.flashcardService.saveFlashcards(this.flashcards!, 'from-text').subscribe((result: any) => {
      this.router.navigate([`/sets/${this.learnset!.id}`], { queryParams: { newCardsAdded: true }});
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event): void {
    event.preventDefault();
    (event as BeforeUnloadEvent).returnValue = '';
  }
}
